module.exports = __webpack_public_path__ + "static/media/adina_tatu.b8364568.jpg";